(function (root) {
  'use strict';

  /** Find required steps not covered by cart items or the current selection. */
  function getMissingSteps(items, requirements, selections = []) {
    const present = new Set(items.filter((item) => Number(item.quantity) > 0)
      .map((item) => String(item.product_id)));
    const supplies = new Set(present);
    selections.forEach((selection) => {
      const quantity = Number(selection.quantity ?? 1);
      if (selection.variantId && Number.isSafeInteger(quantity) && quantity > 0) supplies.add(String(selection.productId));
    });

    const missing = [];
    requirements.forEach((requirement) => {
      if (!present.has(String(requirement.machineProductId))) return;
      requirement.steps.forEach((step) => {
        if (!step.required || step.productIds.some((id) => supplies.has(String(id)))) return;
        missing.push({
          machineProductId: String(requirement.machineProductId),
          machineTitle: requirement.machineTitle,
          machineUrl: requirement.machineUrl,
          stepId: step.id,
          stepTitle: step.title
        });
      });
    });
    return missing;
  }

  /** Pack size is a variant; quantity is the number of those packs. */
  function buildCartItems(mainItem, selections) {
    const items = mainItem ? [{ ...mainItem }] : [];
    const variants = new Set();
    selections.forEach((selection) => {
      const id = String(selection.variantId);
      const quantity = Number(selection.quantity ?? 1);
      if (!selection.variantId || variants.has(id) || !Number.isSafeInteger(quantity) || quantity <= 0) return;
      variants.add(id);
      items.push({ id, quantity, ...(selection.properties ? { properties: selection.properties } : {}) });
    });
    return items;
  }

  const rules = { getMissingSteps, buildCartItems };
  if (typeof module !== 'undefined' && module.exports) module.exports = rules;
  else root.ProductBuilderRules = rules;
})(typeof window === 'undefined' ? globalThis : window);
